import { useMemo } from "react";

import { API_URLS } from "shared/constants";
import useHttpActions from "shared/services/api/core/useHttpActions";

import {
	favoriteGameResponseResolver,
	gameListResponseResolver,
	launchGameResponseResolver,
	listFavoriteGameResponseResolver
} from "shared/types/GameModel";

import type {
	FavoriteGameResponseModel,
	GameListResponseModel,
	GetListGamesRequestParamsModel,
	LaunchGameRequestParamsModel,
	LaunchGameResponseModel,
	ListFavoriteGameResponseModel
} from "shared/types/GameModel";

import BaseConverter from "./converters/baseConverter";

const useGamesService = () => {
	const actions = useHttpActions();

	return useMemo(
		() => ({
			getGames: async (params: GetListGamesRequestParamsModel) => {
				return BaseConverter.convert<GameListResponseModel>(
					await actions.get(API_URLS.GAMES.LIST, params, {
						resolvers: [
							{
								resolver: gameListResponseResolver
							}
						]
					})
				);
			},
			launchGame: async (params: LaunchGameRequestParamsModel) => {
				return BaseConverter.convert<LaunchGameResponseModel>(
					await actions.get(API_URLS.GAMES.LAUNCH, params, {
						resolvers: [
							{
								resolver: launchGameResponseResolver
							}
						]
					})
				);
			},
			favorite: async (gameId: string) => {
				return BaseConverter.convert<FavoriteGameResponseModel>(
					await actions.post(API_URLS.GAMES.FAVORITE(gameId), {
						resolvers: [
							{
								resolver: favoriteGameResponseResolver
							}
						]
					})
				);
			},
			listFavorites: async () => {
				return BaseConverter.convert<ListFavoriteGameResponseModel>(
					await actions.get(API_URLS.GAMES.LIST_FAVORITES, null, {
						resolvers: [
							{
								resolver: listFavoriteGameResponseResolver
							}
						]
					})
				);
			}
		}),
		[actions]
	);
};

export default useGamesService;
